<template>
  <div>
  <myHeader></myHeader>

    <div class="webTarifFEmme webTarifMainBloc">
      <h2>Femmes</h2>
      <div class="webTarifImg">
        <div>
          <img src="../../assets/PrestationFemme2.jpeg" alt="Coupe femme">
          <p class="webTarifTitle">Un moment pour vous, Mesdames</p>
        </div>
        <div>
          <img src="../../assets/Taille des coupes.png" alt="Guide des tailles">
          <p class="webTarifTitle">Guide des tailles</p>
        </div>
      </div>

      <h3 class="webTarifH3Style">Tarifs</h3>
      <div class="webTarifgroup">
        <div class="webTarifEntete">
          <p class="webTarifLines"></p>
          <p></p>
          <p>S</p>
          <p>M</p>
          <p>L</p>
          <p>XL</p>
        </div>
        <div :key="'tarifFiltersWomen' + index" v-for="(tarifFiltersWomen, index) in tarifFiltersWomen">
          <p @click.prevent="editTarif(tarifFiltersWomen._id)" type="submit" class="webTarifNames">
            {{ tarifFiltersWomen.name }}</p>
          <div class="webTarifLines">
            <p class="webTarifValues"></p>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersWomen.priceUnique" type="string" name="priceUnique" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersWomen.priceS" type="string" name="priceS" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersWomen.priceM" type="string" name="priceM" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersWomen.priceL" type="string" name="priceL" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersWomen.priceXL" type="string" name="priceXL" class="webTarifValues"
              disabled="disabled"></vue-numeric>
          </div>
        </div>
      </div>

      <div class="webTarifComplements">
        <!-- <p class="webTarifNames webTarifJustify">*S.P.P. : Service Partiel Personnalisé</p> -->
        <!-- <p class="webTarifNames webTarifJustify">*Les soins classiques sont offerts sur les techniques</p> -->
        <p class="webTarifNames webTarifJustify">* Le shampoing est inclus pour les forfaits Brushing et Coupe. Une réduction de 3 € est appliquée si le shampoing n'est pas réalisé.</p>
        <br>
        <p class="webTarifNames webTarifJustify">* Tous les forfaits techniques incluent une coupe. Une remise de 10 € peut être appliquée dans le cas d'une prestation sans coupe.</p>
        <br>
        <p class="webTarifNames webTarifJustify">Pour toutes les prestations techniques, merci de me contacter pour établir
          un diagnostic</p>
      </div>

      <h3 class="webTarifH3Style">Suppléments</h3>
      <div class="webTarifgroup">
        <div class="webTarifEntete">
          <p class="webTarifLines"></p>
          <p>Forfait</p>
          <p>S</p>
          <p>M</p>
          <p>L</p>
          <p>XL</p>
        </div>
        <div :key="'tarifFiltersSupp' + index" v-for="(tarifFiltersSupp, index) in tarifFiltersSupp">
          <p @click.prevent="editTarif(tarifFiltersSupp._id)" type="submit" class="webTarifNames">{{ tarifFiltersSupp.name }}
          </p>
          <div class="webTarifLines">
            <p class="webTarifValues"></p>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersSupp.priceUnique" type="string" name="priceUnique" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersSupp.priceS" type="string" name="priceS" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersSupp.priceM" type="string" name="priceM" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersSupp.priceL" type="string" name="priceL" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersSupp.priceXL" type="string" name="priceXL" class="webTarifValues"
              disabled="disabled"></vue-numeric>
          </div>
        </div>
      </div>

      <div class="webTarifComplements">
      <p class="webTarifNames webTarifJustify"> Des réductions sur groupes sont applicables, sous conditions (sur toutes
        les prestations adultes) :</p>
      <p class="webTarifNames webTarifReductions">2 personnes : - 5%</p>
      <p class="webTarifNames webTarifReductions">3 personnes : - 10%</p>
      <p class="webTarifNames webTarifReductions">4 personnes : - 15%</p>
      <p class="webTarifNames webTarifReductions">5 personnes et + : - 20%</p>
      </div>

      <h3 class="webTarifH3Style">Cérémonie</h3>
      <div class="webTarifgroup">
        <div class="webTarifEntete">
          <p class="webTarifLines"></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
        <div :key="'tarifFiltersCeremonie' + index" v-for="(tarifFiltersCeremonie, index) in tarifFiltersCeremonie">
          <p @click.prevent="editTarif(tarifFiltersCeremonie._id)" type="submit" class="webTarifNames">
            {{ tarifFiltersCeremonie.name }}</p>
          <div class="webTarifLines">
            <p class="webTarifValues"></p>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFiltersCeremonie.priceS" type="string" name="priceS" class="webTarifValues"
            disabled="disabled"></vue-numeric>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFiltersCeremonie.priceM" type="string" name="priceM" class="webTarifValues"
            disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFiltersCeremonie.priceUnique" type="string" name="priceUnique" class="webTarifValues"
            disabled="disabled"></vue-numeric>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFiltersCeremonie.priceL" type="string" name="priceL" class="webTarifValues"
            disabled="disabled"></vue-numeric>
          <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
            v-model="tarifFiltersCeremonie.priceXL" type="string" name="priceXL" class="webTarifValues"
            disabled="disabled"></vue-numeric>
        </div>
      </div>
    </div>

    <div class="webTarifComplements">
      <p class="webTarifNames webTarifJustify">Les accessoires seront en supplément (postiches, bijoux,...).</p>
      <br>
      <p class="webTarifNames webTarifJustify">Un supplément de 10 à 20 € peut être rajouté sur cheveux très longs</p>
    </div>

  </div>

  <myFooter></myFooter>
  </div>
</template>

<script>
import axios from 'axios'
import VueNumeric from 'vue-numeric'
export default {
  components: {
    VueNumeric
  },
  name: 'webTarifFemmes',
  data () {
    return {
      tarif: []
    }
  },
  mounted () {
    this.getAllTarifs()
  },
  computed: {
    tarifFiltersWomen () {
      return this.tarif.filter(tarif => tarif.category === 'FEMMES')
    },
    tarifFiltersSupp () {
      return this.tarif.filter(tarif => tarif.category === 'SUPPLÉMENTS')
    },
    tarifFiltersCeremonie () {
      return this.tarif.filter(tarif => tarif.category === 'CÉRÉMONIE')
    }
  },
  methods: {
    getAllTarifs () {
      axios
        .get(('https://privilegia.fr/api/tarifs'))
        .then((response) => {
          this.tarif = response.data.sort(function tri (a, b) {
            if (a.name < b.name) { return -1 }
            if (a.name === b.name) { return 0 }
            if (a.name > b.name) { return 1 }
          })
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SiteWeb/WebTarifsFemmes.vue